export default __webpack_public_path__ + "static/media/moonIcon.9eb32fc1.svg";